function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  fill: "#FFFFFF",
  fillRule: "nonzero",
  stroke: "#FFFFFF",
  strokeWidth: 2
}, React.createElement("g", null, React.createElement("path", {
  d: "M17.5,34 C26.6126984,34 34,26.6126984 34,17.5 C34,8.38730163 26.6126984,1 17.5,1 C8.38730163,1 1,8.38730163 1,17.5 C1,26.6126984 8.38730163,34 17.5,34 Z M16.7693668,8.87741667 L25.3861662,15.9544554 C26.2397469,16.6555073 26.3633959,17.9157861 25.662344,18.7693668 C25.5795157,18.8702161 25.4870155,18.9627163 25.3861662,19.0455446 L16.7693668,26.1225833 C15.9157861,26.8236352 14.6555073,26.6999862 13.9544554,25.8464055 C13.6606171,25.4886364 13.5,25.0400071 13.5,24.5770388 L13.5,10.4229612 C13.5,9.31839174 14.3954305,8.42296124 15.5,8.42296124 C15.9629683,8.42296124 16.4115977,8.58357837 16.7693668,8.87741667 Z"
}))));

const SvgStartHoverIcon = ({
  svgRef,
  title,
  ...props
}) => React.createElement("svg", _extends({
  width: "35px",
  height: "35px",
  viewBox: "0 0 35 35",
  ref: svgRef
}, props), title ? React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgStartHoverIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/start-hover-icon.f5bdde80.svg";
export { ForwardRef as ReactComponent };